"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const RewardDefinition_1 = require("./RewardDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({
    text: zod_1.z.string((0, validation_1.labelZodErrors)("Text")).trim().min(1, "Text is required."),
});
exports.default = new RewardDefinition_1.RewardDefinition("TEXT", configSchema, zod_1.z.object({}), (0, validation_1.createZodSchemaValidator)(["config"], configSchema), validation_1.NO_OP_VALIDATOR);
//# sourceMappingURL=TEXT.js.map